import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAllAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './book.reducer';
import { IBook } from 'app/shared/model/book.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IBookProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export class Book extends React.Component<IBookProps> {
  componentDidMount() {
    this.props.getEntities();
  }

  render() {
    const { bookList, match } = this.props;
    return (
      <div>
        <h2 id="book-heading">
          Books
          <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
            <FontAwesomeIcon icon="plus" />&nbsp; Create new Book
          </Link>
        </h2>
        <div className="table-responsive">
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Icon Name</th>
                <th>Banner Name</th>
                <th>Book Url</th>
                <th>Description</th>
                <th>Created Date</th>
                <th>Last Modified Date</th>
                <th>Is Free</th>
                <th>Sport</th>
                <th>Created By</th>
                <th>Last Modified By</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bookList.map((book, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${book.id}`} color="link" size="sm">
                      {book.id}
                    </Button>
                  </td>
                  <td>{book.name}</td>
                  <td>{book.iconName}</td>
                  <td>{book.bannerName}</td>
                  <td>{book.bookUrl}</td>
                  <td>{book.description}</td>
                  <td>
                    <TextFormat type="date" value={book.createdDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>
                    <TextFormat type="date" value={book.lastModifiedDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>{book.isFree ? 'True' : 'False'}</td>
                  <td>{book.sport ? <Link to={`sport/${book.sport.id}`}>{book.sport.name}</Link> : ''}</td>
                  <td>{book.createdBy ? book.createdBy.login : ''}</td>
                  <td>{book.lastModifiedBy ? book.lastModifiedBy.login : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${book.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${book.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${book.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ book }: IRootState) => ({
  bookList: book.entities
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Book);
